import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, withLatestFrom } from 'rxjs/operators';
import { UsersService } from '../../services/users.service';
import { usersActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of, switchMap } from 'rxjs';
import { storeUsersKey } from '../reducers';
import { UsersState } from './users.state';

@Injectable({
  providedIn: 'root',
})
export class UsersEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private usersService: UsersService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        usersActions.findAll,
        usersActions.setPage,
        usersActions.setSearch,
        usersActions.setRole,
      ),
      withLatestFrom(this.store$),
      switchMap(([action, store]) => {
        const usersState = store[storeUsersKey] as UsersState;
        return this.usersService
          .findAll({
            search: usersState.search,
            role: usersState.role,
            page: usersState.page,
            per_page: usersState.per_page,
          })
          .pipe(
            map((response) =>
              usersActions.findAllSuccess({
                users: response.data,
                totalCount: response.total,
              }),
            ),
            catchError((error: ApiError) =>
              of(usersActions.findAllError({ error: error.message })),
            ),
          );
      }),
    ),
  );
}
